// a copy of server/constants specifically for schema

export const DASH_API_BASE_URL = '/api/dash/v1/dashboards';
export const PUBLIC_API_DASH_API_BASE_URL = '/private/api/dash/v1/dashboards';
export const CHARTS_API_BASE_URL = '/api/charts/v1/charts';
